import resolve from 'ioc/resolve'
import templateUrl from 'webmodals/acknowledge.htm'
import open from 'webmodals/open'

export default config => open({
    backdrop: 'static',
    templateUrl,
    size: 'lg',
    scope: Object.assign(resolve('$rootScope').$new(), { 
        title: config.title, 
        list: config.list || [], 
        message: config.message || '', 
        bodyUrl: config.bodyUrl, 
        pledge: config.pledge,
        acknowledged: false,
        now: new Date()
    })
});